const local = '_PROVIDER_ESTADOS_FOLLOWAIR_'
import Vue from 'vue'

var update = false

export default {
	methods: {
		_GET_ESTADO: function (callback) {
			this._httpGet('/Estado/get_estado', function (retorno) {
				if (retorno._request && retorno._status) {
					callback(retorno.lista.length > 0 ? retorno.lista : null)
				} else {
					callback(null)
				}
			})
		},

		_providerEstadoUpdate: function () {
			//console.log("update estado")
			// ESTADOS
			this._GET_ESTADO(function (lista) {
				if (lista != null) {
					var string = JSON.stringify(lista)
					sessionStorage.setItem(local, string)
				}
			})
		},

		_providerEstado: function (callback) {
			//console.log("update estado", update)

			if (!update) {
				update = true
				this._GET_ESTADO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}

			// se existir config do cliente
			if (sessionStorage.getItem(local) != null) {
				callback(JSON.parse(sessionStorage.getItem(local)))
			} else {
				this._GET_ESTADO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}
		}
	}
}